var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.742 11.984l-9.727-9.844A5.79 5.79 0 0 0 30.031.5H6.125C2.961.5.5 3.078.5 6.125v48.75A5.55 5.55 0 0 0 6.125 60.5h33.75c3.047 0 5.625-2.461 5.625-5.625V15.969c0-1.406-.703-2.93-1.758-3.984zM39.406 15.5H30.5V6.594l8.906 8.906zM6.125 54.875V6.125h18.75v12.188c0 1.641 1.172 2.813 2.813 2.813h12.188v33.75H6.125z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.e7081a74facbcbfd49905588a57fe1d1.svg";
export { ForwardRef as ReactComponent };